module.exports = __webpack_public_path__ + "static/media/tee-subli.e6a3116d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/tee-subli.png
// module id = 376
// module chunks = 0